import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import AddEventType from "./AddEventType"
import EditEventType from "./EditEventType"
import EventListType from "./EventListType"

 class Index extends Component {
   constructor(props) {
     super(props);
     this.state = {
       routeStatus: 0,
       dataValue: {},
     };
   }

   changeStatus = (type) => {
     this.setState({
       routeStatus: type,
     });
   };

   changeStatusWithStatusValue = (type, dataValue) => {
     this.setState({
       routeStatus: type,
       dataValue,
     });
   };

   render() {
     const { routeStatus, dataValue } = this.state;
     return (
       <div className="wrapper position-relative">
         {routeStatus == 0 && (
           <EventListType
             changeStatusWithStatusValue={this.changeStatusWithStatusValue}
           />
         )}

         {routeStatus == 1 && <AddEventType changeRouteStatus={this.changeStatus} />}

         {routeStatus == 2 && (
           <EditEventType changeRouteStatus={this.changeStatus} item={dataValue} />
         )}
       </div>
     );
   }
 }
export default (withRouter(Index));